import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ValidatorEditorBase } from '../validator-editor-base/validator-editor-base';
import { FileUploadFileTypeValidatorValue } from '../../../types/validator.types';

@Component({
  selector: 'df-file-upload-file-type-validator-editor',
  templateUrl: './file-upload-file-type-validator-editor.component.html',
  styleUrls: ['./file-upload-file-type-validator-editor.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploadFileTypeValidatorEditorComponent extends ValidatorEditorBase<FileUploadFileTypeValidatorValue>
  implements OnInit {
  ngOnInit() {
    if (!this.caption) {
      this.caption = 'éå¶æä»¶ä¸ä¼ ç±»å';
    }
  }

  defaultModelData(): FileUploadFileTypeValidatorValue {
    return { hasDocument: undefined, hasImage: undefined, hasCompressedPackage: undefined };
  }
}
